let controller1 = new ScrollMagic.Controller();

// secton2 
var box2_title=document.getElementsByClassName('xpb2_title');
let scene2 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimpro_sec2', 
        triggerHook: "onenter",
        duration:0,
        reverse: true
})
// scene2.setPin('.xlimpro_sec2');
scene2.on("progress", function (event) {
    box2_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box2_title[0].classList.remove("showup");
    }
})

// secton5 
var box5_img=document.getElementsByClassName('xpb5_coimg');
var box5_title=document.getElementsByClassName('xpb5_codiv');
let scene5 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimpro_sec5', 
        triggerHook: "onenter",
        duration:0,
        reverse: true
})
scene5.on("progress", function (event) {
    box5_img[0].classList.add("showup");
    setTimeout(function(){
        box5_title[0].classList.add("showup");
    },500)
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box5_img[0].classList.remove("showup");
        setTimeout(function(){
            box5_title[0].classList.remove("showup");
        },500)
    }
})

// secton6 
var box6_title=document.getElementsByClassName('xpb6_title');
let scene6 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimpro_sec6', 
        triggerHook: "onenter",
        duration:0,
        reverse: true
})
scene6.on("progress", function (event) {
    box6_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box6_title[0].classList.remove("showup");
    }
})

// secton7 
var box7_title=document.getElementsByClassName('xpb7_title');
let scene7 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimpro_sec7', 
        triggerHook: "onenter",
        duration:0,
        reverse: true
})
scene7.on("progress", function (event) {
    box7_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box7_title[0].classList.remove("showup");
    }
})

// secton8 
var box8_title=document.getElementsByClassName('xpb8_title');
let scene8 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimpro_sec8', 
        triggerHook: "onenter",
        duration:0,
        reverse: true
})
scene8.on("progress", function (event) {
    box8_title[0].classList.add("showup");
    box8_title[1].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box8_title[0].classList.remove("showup");
        box8_title[1].classList.remove("showup");
    }
})

// secton9 
var box9_title=document.getElementsByClassName('xpb9_content');
let scene9 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimpro_sec9', 
        triggerHook: "onenter",
        duration:0,
        reverse: true
})
scene9.on("progress", function (event) {
    box9_title[0].classList.add("showup");
    box9_title[1].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box9_title[0].classList.remove("showup");
        box9_title[1].classList.remove("showup");
    }
})

// secton10 
var box10_title=document.getElementsByClassName('xpb10_titles');
let scene10 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimpro_sec10', 
        triggerHook: "onenter",
        duration:0,
        reverse: true
})
scene10.on("progress", function (event) {
    box10_title[0].classList.add("showup");
    // box10_title[1].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box10_title[0].classList.remove("showup");
        // box10_title[1].classList.remove("showup");
    }
})

// secton11 
var box11_title=document.getElementsByClassName('xpb11_title');
let scene11 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimpro_sec11', 
        triggerHook: "onenter",
        duration:0,
        reverse: true
})
scene11.on("progress", function (event) {
    box11_title[0].classList.add("showup");
    box11_title[1].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box11_title[0].classList.remove("showup");
        box11_title[1].classList.remove("showup");
    }
})

// secton_se5
var boxs5_title1=document.getElementsByClassName('xsb5_text1');
var boxs5_title2=document.getElementsByClassName('xsb5_text2');
let scenes5 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimSe-sec5', 
        triggerHook: "onenter",
        duration:0,
        reverse: true
})
scenes5.on("progress", function (event) {
    boxs5_title1[0].classList.add("showup");
    boxs5_title1[1].classList.add("showup");
    setTimeout(function(){
        boxs5_title2[0].classList.add("showup");
        boxs5_title2[1].classList.add("showup");
    },500)
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        boxs5_title1[0].classList.remove("showup");
        boxs5_title1[1].classList.remove("showup");
        setTimeout(function(){
            boxs5_title2[0].classList.remove("showup");
            boxs5_title2[1].classList.remove("showup");
        },500)
        
    }
})

// secton_se8
var boxs8_title1=document.getElementsByClassName('xsb8p1');
var boxs8_title2=document.getElementsByClassName('xsb8p2');
var boxs8_title3=document.getElementsByClassName('xsb8p3');
let scenes8 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimSe-sec8', 
        triggerHook: "onenter",
        duration:0,
        reverse: true
})
scenes8.on("progress", function (event) {
    boxs8_title1[0].classList.add("showup");
    setTimeout(function(){
        boxs8_title2[0].classList.add("showup");
    },500)
    setTimeout(function(){
        boxs8_title3[0].classList.add("showup");
        boxs8_title3[1].classList.add("showup");
    },1000)
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        boxs8_title1[0].classList.remove("showup");
        setTimeout(function(){
            boxs8_title2[0].classList.remove("showup");
        },500)
        setTimeout(function(){
            boxs8_title3[0].classList.remove("showup");
            boxs8_title3[1].classList.remove("showup");
        },1000)
    }
})

// secton_se9
var boxs9_title1=document.getElementsByClassName('xsb9p1');
var boxs9_title2=document.getElementsByClassName('xsb9p2');
var boxs9_title3=document.getElementsByClassName('sec9_subContext');
let scenes9 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimSe-sec9', 
        triggerHook: "onenter",
        duration:0,
        reverse: true
})
scenes9.on("progress", function (event) {
    boxs9_title1[0].classList.add("showup");
    setTimeout(function(){
        boxs9_title2[0].classList.add("showup");
        boxs9_title2[1].classList.add("showup");
    },500)
    setTimeout(function(){
        boxs9_title3[0].classList.add("showup");
    },1000)
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        boxs9_title1[0].classList.remove("showup");
        setTimeout(function(){
            boxs9_title2[0].classList.remove("showup");
            boxs9_title2[1].classList.remove("showup");
        },500)
        setTimeout(function(){
            boxs9_title3[0].classList.remove("showup");
        },1000)
    }
})

// secton_se10
var boxs10_title1=document.getElementsByClassName('xsb10p1');
var boxs10_title2=document.getElementsByClassName('xsb10p2');
var boxs10_title3=document.getElementsByClassName('xsb10p3');
let scenes10 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimSe-sec10', 
        triggerHook: "onenter",
        duration:0,
        reverse: true
})
scenes10.on("progress", function (event) {
    boxs10_title1[0].classList.add("showup");
    setTimeout(function(){
        boxs10_title2[0].classList.add("showup");
    },500)
    setTimeout(function(){
        boxs10_title3[0].classList.add("showup");
        boxs10_title3[1].classList.add("showup");
    },1000)
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        boxs10_title1[0].classList.remove("showup");
        setTimeout(function(){
            boxs10_title2[0].classList.remove("showup");
        },500)
        setTimeout(function(){
            boxs10_title3[0].classList.remove("showup");
            boxs10_title3[1].classList.remove("showup");
        },1000)
    }
})

// secton_se11
var boxs11_title1=document.getElementsByClassName('xsb11_title');
var boxs11_title2=document.getElementsByClassName('xsb11_text');
let scenes11 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimSe_newsec11', 
        triggerHook: "onenter",
        duration:0,
        reverse: true
})
scenes11.on("progress", function (event) {
    boxs11_title1[0].classList.add("showup");
    setTimeout(function(){
        boxs11_title2[0].classList.add("showup");
    },500)
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        boxs11_title1[0].classList.remove("showup");
        setTimeout(function(){
            boxs11_title2[0].classList.remove("showup");
        },500)
    }
})

controller1.addScene([scene2,scene5,scene6,scene7,scene8,scene9,scene10,scene11,scenes5,scenes8,scenes9,scenes10,scenes11]); 

$('.pnr_buy').click(function(){
    window.open('https://store.oxva.com/products/oxva-xlim-se-kit');
})

$('.pnr_cart').click(function(){
    var element = document.querySelector(".xlimpro_sec5");
    element.scrollIntoView({block: "end"});
})
$('.pnr_spec').click(function(){
    var element = document.querySelector(".xlimpro_sec10");
    element.scrollIntoView({block: "end"});
})

//section3
var xsb3swiper = new Swiper('.xsb3swiper', {
    pagination: {
        el: '.xsb3swiper-pagination',
        clickable :true,
    }
})
var Mxsb3swiper = new Swiper('.Mxsb3swiper', {
    pagination: {
        el: '.Mxsb3swiper-pagination',
        clickable :true,
    }
})

//section8
const s8mainImg = document.querySelector('.sec8_image');
const s8animationSection = document.querySelector('.xlimSe-sec8');
const s8animationImages = [];
const s8frameCount = 7;

const s8CurrentFrame = index => (
    `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/${index+1}p_XlimSe8.png`
)

const s8PreloadImages = function () {
    for (let i = 0; i < s8frameCount; i++) {
    s8animationImages[i] = new Image();
    s8animationImages[i].src = s8CurrentFrame(i);
    }
};

const s8UpdateImage = index => {
    s8mainImg.src = s8animationImages[index].src;
}

s8PreloadImages();

//section9
// change button border color and main related image
const sec9AllBtns = document.querySelectorAll('.sec9_subText');
const sec9MainImg = document.querySelector('.sec9_image');

function sec9Func(){
    // making all buttons non active by adding css class
    sec9AllBtns.forEach(el=>{
        el.classList.add('notActive')
        el.style.backgroundColor = "transparent"
    });
    
    // changing background color for the selected button
    this.style.backgroundColor = this.dataset.bgclr;
    this.classList.remove('notActive');

    // changing main img dependig on what button is clicked
    sec9MainImg.src = this.dataset.img;
}

sec9AllBtns.forEach(el=>{
    el.addEventListener('click',sec9Func);
})

//section10 
const s10mainImg = document.querySelector('.sec10_image');
const s10animationSection = document.querySelector('.xlimSe-sec10');
const s10animationImages = [];
const s10frameCount = 7;

const s10CurrentFrame = index => (
  `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/${index+1}p_XlimSe10.png`
)

const s10PreloadImages = function () {
  for (let i = 0; i < s10frameCount; i++) {
    s10animationImages[i] = new Image();
    s10animationImages[i].src = s10CurrentFrame(i);
  }
};

const s10UpdateImage = index => {
  s10mainImg.src = s10animationImages[index].src;
}

s10PreloadImages();

//section11
var xpb11_swiper = new Swiper('.xpb11_swiper', {
	// autoplay: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      disabledClass: 'my-button-disabled',
    },
})

var Mxpb11_swiper = new Swiper('.Mxpb11_swiper', {
	// autoplay: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      disabledClass: 'my-button-disabled',
    },
})